import { render, staticRenderFns } from "./ImageAd.vue?vue&type=template&id=8ed28ee4"
import script from "./ImageAd.vue?vue&type=script&lang=js"
export * from "./ImageAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports